import { Fuel } from "../models/fuel.model";

export const FUELS: Fuel[] = [
  { label: "Very Low Sulphur Fuel Oil", value: "VLSFO", code: "VLSFO" },
  { label: "Marine Gas Oil", value: "MGO", code: "MGO" },
];

export function getFuelByCode(code: string): Fuel | undefined {
  return FUELS.find(fuel => fuel.value === code || fuel.code === code);
}

export function getFuelByName(name: string): Fuel | undefined {
  return FUELS.find(fuel => 
    fuel.label.toLowerCase().includes(name.toLowerCase())
  );
}

export function getFuelCodes(): string[] {
  return FUELS.map(fuel => fuel.value);
}

export function getFuelNames(): string[] {
  return FUELS.map(fuel => fuel.label);
}
